import { z } from 'zod'

/**
 * Which flow a provider is routed through when adding or re-verifying a bank
 * account in the provider portal. Mirrors providers.bank_linking_provider and
 * shares its vocabulary with provider_bank_accounts.linking_provider.
 */
export const BANK_LINKING_PROVIDER_PLAID = 'plaid'

export const BANK_LINKING_PROVIDER_MANUAL = 'manual'

export const BankLinkingProviderSchema = z.enum([
  BANK_LINKING_PROVIDER_PLAID,
  BANK_LINKING_PROVIDER_MANUAL,
])

export type BankLinkingProvider = z.infer<typeof BankLinkingProviderSchema>

/**
 * Normalises the value stored on a provider. Anything unrecognised - including
 * an API that predates the column - reads as Plaid, which is the column default
 * and the flow every provider is on unless an admin moves them off it.
 */
export const resolveBankLinkingProvider = (
  value?: string | null
): BankLinkingProvider =>
  value?.toLowerCase() === BANK_LINKING_PROVIDER_MANUAL
    ? BANK_LINKING_PROVIDER_MANUAL
    : BANK_LINKING_PROVIDER_PLAID
